<template>
    <tr>
        <td class="px-6 py-3">
            {{ request.equipment.join(', ') }}<br>
            <span v-show="request.comment">Anmerkung: {{ request.comment }}</span>
        </td>
        <td class="px-6 py-3">
            <span v-if="request.user">{{ request.user.first_name }} {{ request.user.name }}</span>
        </td>
        <td class="px-6 py-3">
            {{ request.start | date }} {{ request.start | time }} - {{ request.end | time }} Uhr
        </td>
        <td class="px-6 py-3 text-right whitespace-nowrap">
            <button-secondary @click="open">
                <i class="fa fa-check text-green-500 mr-2"></i> Bestätigen
            </button-secondary>
            <button-secondary @click="declineRequest">
                <i class="fa fa-times text-red-500 mr-2"></i> Ablehnen
            </button-secondary>
        </td>
        <portal to="dialog" v-if="showRequest">
            <modal @close="showRequest = false">
                <template slot="header">Anfrage bestätigen</template>

                <loading v-show="loading"></loading>

                <div v-if="!loading">

                    <p v-show="request.equipment.length > 0">
                        Equipment: {{ request.equipment.join(', ') }}
                    </p>

                    <p>
                        Zeitraum:
                        {{ request.start | date }} {{ request.start | time }} - {{ request.end | time }} Uhr
                    </p>

                    <select-menu class="mb-4"
                                 v-model="bookable"
                                 :text="bookables.map(b => b.name)"
                                 :values="bookables.map(b => b.id)">
                        Raum
                    </select-menu>

                    <input-text class="mb-8" v-model="comment">
                        Kommentar
                        <template slot="helper">Zusätzliche Information für den User, z.B. Besonderer Raum, PIN-Code, Schlüssel, etc.</template>
                    </input-text>

                    <div class="flex justify-end">
                        <button-primary @click="confirmRequest">
                            <i class="fa fa-save mr-2"></i> Bestätigen
                        </button-primary>
                    </div>
                </div>
            </modal>
        </portal>
    </tr>
</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import Modal from "../Modal.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import SelectMenu from "../UI/SelectMenu.vue";
import Loading from "../UI/Loading.vue";
import InputText from "../UI/InputText.vue";

export default {
    name: "BookableRequest",

    props: ['request'],

    components: {InputText, Loading, SelectMenu, ButtonPrimary, Modal, ButtonSecondary},

    data: () => ({
        showRequest: false,
        loading: false,
        comment: '',
        bookable: null,
        bookables: [],
    }),

    filters: {
        time(val) {
            return val.substr(11, 5);
        },
        date(val) {
            let [y, m, d] = val.substr(0, 10).split('-');
            return `${d}.${m}.${y}`;
        },
    },

    methods: {
        open() {
            this.showRequest = true;
            this.loading = true;

            this.$http.get('/admin/bookables')
                .then((response) => {
                    this.bookables = [{
                        name: 'Bitte auswählen',
                        id: null,
                    }]
                        .concat(response.data.data.filter(bookable => bookable.bookable_category_id === this.request.bookable_category_id));
                    this.loading = false;
                })
        },
        declineRequest() {
            this.loading = true;
            this.$http
                .put(`/admin/bookable_booking_requests/${this.request.id}`, {
                    status: 'denied',
                })
                .then(() => {
                    if (status === 'denied') {
                        this.$root.$emit('alert', 'Anfrage wurde abgelehnt.');
                    }

                    this.$emit('reload');
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },
        confirmRequest() {
            if (!this.bookable) {
                alert('Wähle einen Raum aus.');
                return;
            }
            this.loading = true;
            this.$http
                .put(`/admin/bookable_booking_requests/${this.request.id}`, {
                    status: 'confirmed',
                    bookable: this.bookable,
                    comment: this.comment,
                })
                .then(() => {
                    if (status === 'confirmed') {
                        this.$root.$emit('alert', 'Anfrage wurde bestätigt.');
                    }

                    //this.load();
                    this.showRequest = false;
                    this.$emit('reload');
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                    this.loading = false;
                });
        },

    }
}
</script>

<style scoped>

</style>
